import { AppConfig } from "./environement";

export const font = "futura-pt-condensed, sans-serif;";
export const proEnabled = AppConfig.app.proEnabled ?? false;
// RevenueCat entitlement that unlocks all Rhapsody Pro features — must match
// the entitlement lookup key in the RevenueCat dashboard.
export const proEntitlementID = "Rhapsody Subscriptions";
export const typeOptions = [
  {
    id: 1,
    title: "Rehearsal",
    icon: "fas fa-list-music",
    sessionTypeID: 13,
  },
  {
    id: 2,
    title: "Dress Rehearsal",
    icon: "fas fa-user-tie",
    sessionTypeID: 14,
  },
  {
    id: 3,
    title: "Sound Check",
    icon: "fas fa-speaker",
    sessionTypeID: 15,
  },
  {
    id: 4,
    title: "Performance",
    icon: "fas fa-theater-masks",
    sessionTypeID: 2,
  },
  {
    id: 5,
    title: "Recording Session",
    icon: "fas fa-microphone",
    sessionTypeID: 1,
  },
];

export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
});
